// react imports
import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Document, Page } from "react-pdf";
import ReactPlayer from "react-player";

import video_1 from "../assets/media/videos/video_1.mp4";

import { pdfjs } from "react-pdf";

// CUSTOM COMPONENTS
import AppContext from "../AppContext";

import { MDBContainer } from "mdb-react-ui-kit";

import romaito from "../assets/media/images/romaito.png";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

const LandingPage = (props) => {
  const context = useContext(AppContext);
  let [searchParams] = useSearchParams();

  useEffect(() => {}, []);

  return (
    <MDBContainer>
      <div className="oval">
        {/*<img src={romaito} alt="" />
        <iframe
          src={video_1 + "?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"}
          allowFullScreen
          className="video-content"
        ></iframe>*/}
        <ReactPlayer src={video_1} style={{ width: "100%", height: "auto", borderRadius: "8px" }} controls={"true"} />
      </div>
      <p className="home-description">
        A Római-tó (régi nevén Agostyáni-tó), Komárom-Esztergom megyében, Tata központjától 2 km-re Agostyán irányában
        található a Gerecse lábánál. A Római völgyben elterülő tiszta vízű forrásokból eredő tó, a vidék egyik legszebb
        tava. Visszatérő forrásokban bővelkedő a terület, mely érezhető a tó vízminőségének javulásában is. A tó
        gyökerei visszanyúlnak egészen a római korig, amikor is római kori telepesek, leszolgált római katonák éltek
        itt. A tó i.sz. 150-től létezik. 1968-tól 1971-ig mezőgazdasági locsoló tónak épült, de ezt a funkcióját soha
        nem töltötte be. Később a TSZ Horgász Egyesületéhez tartozott, akitől jelenlegi tulajdonosa vette 1997-ben, és
        nevezte el Római-tónak, régre visszanyúló múltja miatt. Ebből az időből származnak a tóban lévő kapitális halak.
        A tó 12 ha vízfelületű. Az átlag mélysége 1,5 - 3 m. Talaja: agyag, márga, kő és egy kevés 5-10 cm-es iszap is
        található, nagyméretű süllőtartásokkal (akadókkal). Az egész völgy egy tulajdonos kezében van, így minden
        különleges rendezvényre való igényt teljesíteni tudunk. A tavon 26 db stéges ház található, melyek egy stég
        bejáróról közelíthetők meg. A parti részen 20 sátras hely és 9 napijegyes hely lett kialakítva stégekkel. A
        területen több WC blokk, a főépületben fürdő és büfé is található. A sátras helyeknél is van lehetőség áram
        vételére, amely további kényelmet jelenthet a horgászat szerelmeseinek.
      </p>
    </MDBContainer>
  );
};

export default LandingPage;
